import React from "react";
import { TextField } from "@mui/material";

// Custom TextField component with reusable styles
const CustomTextField = (props) => {
  return (
    <TextField
      {...props}
      size="small" // Ensures tight spacing
      InputProps={{
        ...props.InputProps,
        sx: {
          backgroundColor: '#fff',
          ...props.InputProps?.sx,
        },
      }}
      sx={{
        "& .MuiInputBase-input": {
          padding: "8px 10px", // Best balance for alignment
          fontSize: { sm: "12px", lg: "14px" },
        },
        ...props.sx,
      }}
    />
  );
};

export default CustomTextField;
